
export enum NotificationStatus {
  Success = 'success',
  Failure = 'failure',
  Info = 'info',
}

export interface Notification {
  readonly status: NotificationStatus;
  readonly title: string;
}

export interface ServerNotification extends Notification {
  readonly body?: string;
  readonly data?: {};
  readonly status: NotificationStatus;
  readonly timestamp: string;
  readonly title: string;
}

export class ClientNotification implements Notification {
  readonly status: NotificationStatus;
  readonly title: string;

  static info(title: string): ClientNotification {
    return { title, status: NotificationStatus.Info };
  }

  static error(title: string): ClientNotification {
    return { title, status: NotificationStatus.Failure };
  };

  static success(title: string): ClientNotification {
    return { title, status: NotificationStatus.Success };
  };
}

export interface ProjectionNotification extends Notification {
  readonly status: NotificationStatus;
  readonly title: string;
  readonly eventType: string;
}
